
function Characteristics({props}) {
    let Characteristics = props.map ((item, idx) =>
        {    
            return (
                <div className="description__characteristics" key={idx}>
                    <img alt="" src={item.icon} className="description__icon" loading="lazy"/>
                    <div className="description__characteristic">
                        {item.text}
                    </div>
                </div>
            )
        })
    return (
        <div className="description__characteristics-item">
            {Characteristics}
        </div>
    )
}
export default Characteristics;